import { upsertHowItWorks, upsertTierLevel } from "../../datasource/TierProgramDatasource";
import { Step2Result } from "./CreateShopTierBenefitStep/Step2";
import { toRebatePercent } from "./rebatePercent";

const UPSERT_TIER_LEVEL_DELAY_MS = 100;

interface Profile {
  company: string;
  firstname: string;
  lastname: string;
}

// Shared by create and edit: both write how-it-works cards and every tier level
// against an existing tierProgramId through the upsert endpoints.
export async function saveHowItWorksAndTierLevels(
  tierProgramId: string,
  data: Step2Result,
  profile: Profile,
): Promise<void> {
  const updatedBy = profile.firstname + " " + profile.lastname;

  await upsertHowItWorks(
    tierProgramId,
    JSON.stringify(
      data.cards.map((card) =>
        !card.File
          ? { title: card.title, detail: card.description, imageUrl: card.iconPath, changeImage: false }
          : { title: card.title, detail: card.description, changeImage: true },
      ),
    ),
    data.cards.filter((card) => card.File != null).map((card) => card.File) as File[],
    updatedBy,
  );

  const tiers = data.tiers;
  for (let i = 0; i < tiers.length; i++) {
    const tier = tiers[i];
    const file: File | null = data.cardImageOverridesFile?.[tier.tierKey] ?? null;
    const fileBg: File | null = data.cardBackgroundOverridesFile?.[tier.tierKey] ?? null;
    await new Promise((resolve) => setTimeout(resolve, UPSERT_TIER_LEVEL_DELAY_MS));
    await upsertTierLevel(
      tierProgramId,
      i + 1,
      tier.tierKey,
      JSON.stringify(
        tier.benefits.map((benefit) =>
          !benefit.File
            ? {
                benefitName: benefit.title,
                benefitDetail: benefit.description,
                benefitImageUrl: benefit.iconPath,
                changeImage: false,
              }
            : { benefitName: benefit.title, benefitDetail: benefit.description, changeImage: true },
        ),
      ),
      updatedBy,
      tier.tierTitle!,
      tier.titleDescription!,
      toRebatePercent(tier.percent),
      tier.color,
      profile.company === "ICPL",
      profile.company !== "ICPL" ? tier.preventAutoDemote : false,
      tier.queueThresholdPercent,
      tier.benefits.filter((b) => b.File != null).map((b) => b.File) as File[],
      file!,
      tier.tierImageUrl,
      fileBg!,
      tier.tierBgImageUrl,
    );
  }
}
